import { Grid } from "@mui/material";
import { DateField, FunctionField, Labeled, NumberField, SelectField, TextField } from "react-admin";
import { PublicationSourceChoices } from "utils/choices";
import DoiLink from "../Partials/DoiLink";

const InfoSection = () => (
  <Grid
    container
    spacing={2}
  >
    <Grid
      item
      xs={12}
    >
      <Labeled label="Заглавие">
        <TextField
          source="title"
          emptyText="-"
        />
      </Labeled>
    </Grid>
    <Grid
      item
      xs={12}
      md={4}
    >
      <Labeled label="DOI">
        <FunctionField render={record => <DoiLink doi={record.doi} />} />
      </Labeled>
    </Grid>
    <Grid
      item
      xs={12}
      md={4}
    >
      <Labeled label="Тип">
        <TextField
          source="documentType"
          emptyText="-"
        />
      </Labeled>
    </Grid>
    <Grid
      item
      xs={12}
      md={4}
    >
      <Labeled label="Език">
        <TextField
          source="language"
          emptyText="-"
        />
      </Labeled>
    </Grid>
    <Grid
      item
      xs={12}
      md={4}
    >
      <Labeled label="Година">
        <NumberField
          source="year"
          options={{ useGrouping: false }}
          emptyText="-"
        />
      </Labeled>
    </Grid>
    <Grid
      item
      xs={12}
      md={4}
    >
      <Labeled label="Дата на публикуване">
        <DateField
          source="publicationDate"
          locales="bg-BG"
          emptyText="-"
        />
      </Labeled>
    </Grid>
    <Grid
      item
      xs={12}
      md={4}
    >
      <Labeled label="Цитирания">
        <NumberField
          source="citationCount"
          emptyText="-"
        />
      </Labeled>
    </Grid>
    <Grid
      item
      xs={12}
      md={4}
    >
      <Labeled label="Източник">
        <SelectField
          source="source"
          choices={PublicationSourceChoices}
          emptyText="-"
        />
      </Labeled>
    </Grid>
    <Grid
      item
      xs={12}
      md={4}
    >
      <Labeled label="Идентификатор в източника">
        <TextField
          source="sourcePublicationId"
          emptyText="-"
        />
      </Labeled>
    </Grid>
    <Grid
      item
      xs={12}
      md={4}
    >
      <Labeled label="Последно обновена">
        <DateField
          source="retrievedAt"
          locales="bg-BG"
          showTime
          emptyText="-"
        />
      </Labeled>
    </Grid>
  </Grid>
);

export default InfoSection;
